'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../node_modules/prop-types/index.js');
var Row = require('./Row.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var DataWindow = _ref => {
  var {
    rowCount,
    topRow,
    bottomRow,
    rowHeight,
    actionsWidth,
    scrollbarWidth
  } = _ref;
  var rows = [];

  for (var index = topRow; index <= bottomRow; index += 1) {
    rows.push( /*#__PURE__*/React__namespace.createElement(Row.Row, {
      key: index,
      rowIndex: index,
      top: index * rowHeight,
      rowHeight: rowHeight,
      actionsWidth: actionsWidth,
      scrollbarWidth: scrollbarWidth
    }));
  }

  var totalHeight = rowCount * rowHeight;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "GenjoDataTable__scroll-container",
    style: {
      height: totalHeight,
      maxHeight: totalHeight,
      minHeight: totalHeight
    }
  }, rows);
};
DataWindow.propTypes = {};

exports.DataWindow = DataWindow;
